import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "/api";
const base = `${apiUrl}/app/api`;

export function loadPublicTimetable(params = {}) {
  const { campus, academic, semester, programme, year, day, instructor } = params;
  let url = `${base}/public/timetable?`;
  if (campus) url += `campus=${campus}&`;
  if (academic) url += `academic=${academic}&`;
  if (semester) url += `semester=${semester}&`;
  if (programme) url += `programme=${programme}&`;
  if (year) url += `year=${year}&`;
  if (day) url += `day=${day}&`;
  if (instructor) url += `instructor=${instructor}`;
  return axios.get(url);
}

export function loadPublicExam(params = {}) {
  const { campus, academic, semester, programme, year } = params;
  let url = `${base}/public/exam?`;
  if (campus) url += `campus=${campus}&`;
  if (academic) url += `academic=${academic}&`;
  if (semester) url += `semester=${semester}&`;
  if (programme) url += `programme=${programme}&`;
  if (year) url += `year=${year}`;
  return axios.get(url);
}

export const loadPublicProgrammes = () => axios.get(`${base}/public/programmes`);
export const loadPublicCampuses = () => axios.get(`${base}/public/campuses`);
export const loadPublicAcademicYears = () => axios.get(`${base}/public/academic-years`);
export const loadPublicSemesters = (id) => axios.get(`${base}/public/semesters${id ? `?academic=${id}` : ""}`);
export const loadPublicInstructors = (campus, academic) => {
  let url = `${base}/public/instructors?`;
  if (campus) url += `campus=${campus}&`;
  if (academic) url += `academic=${academic}`;
  return axios.get(url);
};

export function loadPublicUploadedTimetables(params = {}) {
  const { campus, academic, semester, type } = params;
  let url = `${base}/public/uploaded-timetables?`;
  if (campus) url += `campus=${campus}&`;
  if (academic) url += `academic=${academic}&`;
  if (semester) url += `semester=${semester}&`;
  if (type) url += `type=${type}`;
  return axios.get(url);
}

export function getUploadedTimetableDownloadUrl(id) {
  return `${base}/uploaded-timetable/${id}/download`;
}

export function loadUploadedEntries(id) {
  return axios.get(`${base}/uploaded-timetable/${id}/entries`);
}
